import axios from 'axios';
import { BASE_URL } from '@/assets/js/config';
import { getAccessToken } from '@/assets/js/auth';

export const getDatabases = async (apiUrl) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
    }
  };

  return axios.get(`${apiUrl}/servers`, settings);
  // return axios.get(`${apiUrl}/instances`, settings);
}

export const getDatabaseDetails = async (apiUrl, instace_id) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  return axios.get(`${apiUrl}/servers/${instace_id}`, settings);
  // return axios.get(`${apiUrl}/instances/${instace_id}`, settings);
}

export const deleteDatabase = async (apiUrl, instace_id) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  return axios.delete(`${apiUrl}/servers/${instace_id}`, settings);
  // return axios.delete(`${apiUrl}/instance/${instace_id}`, settings);
}

export const createDatabase = async (apiUrl, data) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
    }
  };

  return axios.post(`${apiUrl}/servers`, data, settings);
  // return axios.post(`${apiUrl}/instance`, data, settings);
}

export const updateInstanceName = async (apiUrl, instanceId, data) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  // return axios.put(`${apiUrl}/servers/${instanceId}`, data, settings);
  return axios.put(`${apiUrl}/instance/${instanceId}`, data, settings);
}

export const instanceAction = async (apiUrl, instanceId, data) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
    }
  };

  return axios.post(`${apiUrl}/servers/${instanceId}/action`, data, settings);
  // return axios.post(`${apiUrl}/instance/${instanceId}/action`, data, settings);
}

// DB USER
export const getDatabaseUsers = async (apiUrl, databaseId) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
    }
  };

  return axios.get(`${apiUrl}/instances/${databaseId}/users`, settings);
}

export const deleteDatabaseUser = async (apiUrl, instace_id, userName) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  return axios.delete(`${apiUrl}/instances/${instace_id}/users/${userName}`, settings);
}

// DATABASES
export const getDatabaseDatabases = async (apiUrl, database_id) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
    }
  };

  return axios.get(`${apiUrl}/instances/${database_id}/databases`, settings);
}

export const deleteDatabaseDatabase = async (apiUrl, instace_id, database_name) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  return axios.delete(`${apiUrl}/instances/${instace_id}/databases/${database_name}`, settings);
}

// BACKUPS
export const getDatabaseBackups = async (apiUrl, instace_id) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
    }
  };

  if (instace_id) {
      return axios.get(`${apiUrl}/backups?instance_id=${instace_id}`, settings);
  } else {
      return axios.get(`${apiUrl}/backups`, settings);
  }
}

export const createDatabaseBackup = async (apiUrl, data) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
    }
  };

  return axios.post(`${apiUrl}/servers`, data, settings);
  // return axios.post(`${apiUrl}/instance`, data, settings);
}

export const deleteDatabaseBackup = async (apiUrl, instace_id, backup_id) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  return axios.delete(`${apiUrl}/instances/${instace_id}/backups/${backup_id}`, settings);
}
